import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';

const MemberOnlyOverlay = ({ children, previewTitle }) => {
  const { t } = useTranslation();
  const { isAuthenticated, isApproved, isPending } = useAuth();

  if (isAuthenticated && isApproved) return <>{children}</>;

  if (isAuthenticated && isPending) {
    return (
      <div className="member-only-wrapper" data-testid="member-only-wrapper">
        <div className="member-only-content">{children}</div>
        <div className="member-only-overlay" data-testid="pending-overlay">
          <h2 data-testid="overlay-title"><i className="fas fa-clock" style={{ color: '#e67e22' }}></i> {t('overlay.pendingTitle')}</h2>
          <p>{t('overlay.pendingDesc')}</p>
          <Link to="/profile" className="btn">{t('overlay.viewProfile')}</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="member-only-wrapper" data-testid="member-only-wrapper">
      <div className="member-only-content" data-testid="member-only-preview">{children}</div>
      <div className="member-only-overlay" data-testid="member-only-overlay">
        <h2 data-testid="overlay-title"><i className="fas fa-lock"></i> {t('overlay.membersOnly')}</h2>
        <p data-testid="overlay-message">{t('overlay.membersOnlyDesc', { content: previewTitle || 'content' })}</p>
        <div className="button-group">
          <Link to="/auth" className="btn" data-testid="overlay-login-button">{t('overlay.signIn')}</Link>
          <Link to="/auth" className="btn btn-secondary" data-testid="overlay-register-button">{t('overlay.register')}</Link>
        </div>
      </div>
    </div>
  );
};

export default MemberOnlyOverlay;
